<template>
  <div id="member-communications" class="module">
    <h1>Member Communications</h1>

    <el-card class="box-card">
      <div class="flexbox flexbox__v-center">
        <img src="@/assets/member-communications.png" width="162" />

        <div class="content">
          <p>{{ $attrs.message }}</p>

          <p>
            <strong>{{ $attrs.emails | sentenceList }}</strong>
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "MemberCommunications",
  filters: {
    sentenceList: function(arr) {
      return arr
        .reduce(function(prev, curr, i) {
          return prev + curr + (i === arr.length - 2 ? " and " : ", ");
        }, "")
        .slice(0, -2);
    }
  }
};
</script>

<style lang="scss" scoped>
div.content {
  margin-left: 2.5rem;
}
</style>
